<template>
  <div class="body-row quality">
    <div :id="`${id}-label`" class="body-row-left">{{ label }} {{ required ? '*' : '' }}</div>
    <div class="body-row-right">
      <div class="stars">
        <div class="star" :class="{ 'rfp-rr-rating-rtl-float-right': rtl }">
          <refapp-star-rating
            ref="starRating"
            :aria-labelledby="`${id}-label`"
            :aria-label="starRatingAccessibleLabel"
            class="vue-star-rating"
            star-classes="vue-star-rating-star"
            :increment="increment"
            :max-rating="maxRating"
            :inactive-color="inactiveColor"
            :active-color="activeColor"
            :star-size="starSize"
            :rating="value"
            :required="required"
            :aria-invalid="!!validationError"
            :aria-describedby="!!validationError ? `${id}-error-message` : null"
            @update:rating="hndChange"
          ></refapp-star-rating>
        </div>
      </div>
      <div class="star-label" v-text="options[itoa[value]]"></div>
      <p
        v-if="validationError"
        :id="`${id}-error-message`"
        class="Refapp-ratings-validation-error"
        v-text="validationErrorMessage"
      ></p>
    </div>
  </div>
</template>

<script>
import RefappStarRating from '../../../../../shared/components/star-rating/refapp-star-rating.vue';

export default {
  name: 'rfp-ratings-write-optional-stars',
  components: {
    RefappStarRating,
  },
  inject: [
    'increment',
    'maxRating',
    'inactiveColor',
    'activeColor',
    'starSize',
    'starRatingAccessibleLabel',
  ],
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => {},
    },
    rtl: {
      type: Boolean,
      default: false,
    },
    validationError: {
      type: [String, null],
      default: null,
    },
    validationErrorMessage: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: 0,
    },
    required: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
  },
  created() {
    // converts a numeric 1-5 into one, two..etc gods have mercy on who came up with this keying
    this.itoa = {
      0: 'default',
      1: 'one',
      2: 'two',
      3: 'three',
      4: 'four',
      5: 'five',
    };
  },
  methods: {
    // we opted to use manual event emission as v-model is broken between vue 2 and 3
    hndChange(newValue) {
      this.$emit('update', newValue);
    },
    focus() {
      this.$refs.starRating.focus();
    },
  },
};
</script>
